export const contractOptions = [
  { optionText: "Licença Anual - 1.0", value: "1.0" },
  { optionText: "Licença Mensal - 2.0", value: "2.0" },
];
